import {isEmptyJsonObject} from "../../../common/utils/helper"
export const isJiraAdmin=(adminPermission)=>{
    if(!adminPermission){
        return false;
    }
    if(isEmptyJsonObject(adminPermission)){
        return false;
    }    
    // Check if ADMINISTER permission exists and havePermission is true
    if (adminPermission.permissions && 
        adminPermission.permissions.ADMINISTER && 
        adminPermission.permissions.ADMINISTER.havePermission === true) {
        return true;
    }

    return false;
  }